import { unique } from './array';
import isNumeric from './isNumeric';

export const STRING_SPLIT_DELIMITER = /[\s,|;]+/;

/**
 * Splits a string by most common delimiters `whitespace` `,` `|` `;`. Omits empty values.
 * @param value string
 * @param delimiter RegExp | string (default: /[\s,|;]+/)
 * @returns string[]
 */
export function split(value: string, delimiter: RegExp | string = STRING_SPLIT_DELIMITER) {
  return value.split(delimiter).filter(Boolean);
}

/**
 * Splits a string into `integers`
 * @param value string
 * @returns number[]
 */
export function splitToInt(value: string) {
  return split(value)
    .filter(isNumeric) // filter all non numeric
    .map(id => parseInt(id, 10));
}

/**
 * Splits a string into `integers` and removing duplicates
 * @param value string
 * @returns number[]
 */
export function splitToUniqueInt(value: string) {
  return unique(splitToInt(value));
}
